import script from "./ControlPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlPanel.vue?vue&type=script&setup=true&lang=js"

import "./ControlPanel.vue?vue&type=style&index=0&id=81152424&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81152424"]])

export default __exports__